import { render, staticRenderFns } from "./MyProgramRegistraions.vue?vue&type=template&id=64c9812c&scoped=true"
import script from "./MyProgramRegistraions.vue?vue&type=script&lang=js"
export * from "./MyProgramRegistraions.vue?vue&type=script&lang=js"
import style0 from "./MyProgramRegistraions.vue?vue&type=style&index=0&id=64c9812c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9812c",
  null
  
)

export default component.exports